import { Icon } from '@chakra-ui/react';
import IconCheck from 'assets/icons/icon-check.svg?react';
import {
  GroupBase,
  OptionProps,
  chakraComponents
} from 'chakra-react-select';

const Option = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
  >(
  { children, ...props }: OptionProps<Option, IsMulti, Group>
  ) => (
  <chakraComponents.Option {...props}>
    <>
      { props.isSelected && <Icon as={IconCheck} boxSize="20px" pos="absolute" ml="-2px" mt="2px" alignSelf="flex-start" /> }
      { children }
    </>
  </chakraComponents.Option>
);

export default Option;